import { render } from "./list-role.vue?vue&type=template&id=19254a9a"
import script from "./list-role.vue?vue&type=script&lang=js"
export * from "./list-role.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__